import {storage} from './index';
import {getDownloadURL, ref} from 'firebase/storage';


export const getStorageDownloadURL = (filePath) => getDownloadURL(ref(storage, filePath));

export const getImageDownloadURL = (imageName) => getStorageDownloadURL(`images/${imageName}`);

export const getPDFDownloadURL = (fileName) => getStorageDownloadURL(`pdfs/${fileName}`);
